export default __webpack_public_path__ + "static/media/65t.b3a24254.jpg";